export default __webpack_public_path__ + "static/media/tag.e57b91b9.svg";